import React from "react";
import BaseComponent from "../BaseComponent";
import styled from "styled-components";
import nota from "../Global/nota.guidelines.json";
import { dateComparison } from "../Nano/DateRangePicker.js";
import moment from "moment";
import { Popper, Reference, Manager } from "react-popper";

import NanoFlex from "../Global/NanoFlex.js";
import DateRangePicker from "../Nano/DateRangePicker.js";
import InputDate from "../Nano/InputDate.js";

import { ReactComponent as CalendarIcon } from "../Global/Icons/calendar.svg";
import Type from "../Global/Typography.js";

const multiple = nota.global.multiple;

let securityBlocker = true;
const securityBlockerAction = () => {
  securityBlocker = false;
  setTimeout(() => {
    securityBlocker = true;
  }, 300);
};

const checkInvalidDate = (d) => (d !== "Invalid date" ? d : null);

const mock = {
  startDate: "27-02-2020",
  endDate: "27-04-2020",
};

const StyledCalendar = styled.div`
  width: ${multiple * 29 + "px"};

  h6 {
    margin-bottom: 2px;
  }
  .inputDateContainer {
    margin-right: 4px;
  }
  .icon {
    padding-top: 12px;
    width: 20px;
    cursor: pointer;
    svg path {
      fill: ${(props) => (props.isOpen ? nota.color.main.default : nota.color.neutral.NeuOne)};
    }
    &:hover {
      opacity: 0.7;
    }
  }
  .dropdown-content {
    position: absolute;
    border: 1px solid ${nota.color.neutral.NeuTwo};
    left: 45%;
    margin: 20px 0 0 0;
  }

  .popUpContainer {
    z-index: 1;
    background-color: ${nota.color.neutral.white};
    .datePickerWrapper {
      box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
    }
  }
  .iconWrapper {
    width: auto;
  }
`;

class Calendar extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      startDate: null,
      endDate: null,
      onClickCounter: 0,

      isOpenDropdown: false,
    };

    this.calendarRef = React.createRef();
  }

  componentDidMount() {
    super.componentDidMount();
    if (this.props.inputDate) this.setState(this.updateDates(this.props.inputDate));
    document.addEventListener("mousedown", this.handleOutsideClick);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.startDate !== this.state.startDate || prevState.endDate !== this.state.endDate) {
      // if (prevState.startDate === null && prevState.endDate === null) {
      //   this.setState({ endDate: this.state.startDate ?? this.state.endDate, startDate: this.state.startDate ?? this.state.endDate });
      // } else {
      let range = this.updateDates({ startDate: this.state.startDate, endDate: this.state.endDate });

      if (range.startDate !== this.state.startDate || range.endDate !== this.state.endDate) {
        this.setState(range);
      } else {
        //Validate min max date
        const newDate = {
          startDate: checkInvalidDate(this.state.startDate) !== null ? this.state.startDate : null,
          endDate: checkInvalidDate(this.state.endDate) !== null ? this.state.endDate : null,
        };
        this.props.onChangeSelection(newDate);
      }
      // }
    }

    if (prevProps.inputDate !== this.props.inputDate || this.props.forceSelection) {
      this.setState(this.updateDates(this.props.inputDate));
    }

    if (prevProps.minDate !== this.props.minDate || prevProps.maxDate !== this.props.maxDate) {
      this.setState(this.updateDates({ startDate: this.state.startDate, endDate: this.state.endDate }));
    }

    if (this.state.isOpenDropdown !== prevState.isOpenDropdown && this.props.isOpenDropdownChanged) {
      this.props.isOpenDropdownChanged(this.state.isOpenDropdown);
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    document.removeEventListener("mousedown", this.handleOutsideClick);
  }

  updateDates = (inputDate) => {
    const input = { ...inputDate };
    const dateFormat = nota.global.moment.serverDate;

    if (this.props.minDate && moment(input.startDate, dateFormat) < this.props.minDate) {
      input.startDate = moment(this.props.minDate, dateFormat).format(dateFormat);
    }

    if (this.props.maxDate && moment(input.startDate, dateFormat) > this.props.maxDate) {
      input.startDate = moment(this.props.maxDate, dateFormat).format(dateFormat);
    }

    if (this.props.minDate && moment(input.endDate, dateFormat) < this.props.minDate) {
      input.endDate = moment(this.props.minDate, dateFormat).format(dateFormat);
    }

    if (this.props.maxDate && moment(input.endDate, dateFormat) > this.props.maxDate) {
      input.endDate = moment(this.props.maxDate, dateFormat).format(dateFormat);
    }

    const start = moment(input.startDate, dateFormat).format(dateFormat);
    const end = moment(input.endDate, dateFormat).format(dateFormat);

    return {
      startDate: checkInvalidDate(start),
      endDate: checkInvalidDate(end),
    };
  };

  updateMainState = (newStartDate, newEndDate) => {
    if (!securityBlocker) return;
    securityBlockerAction();

    if (this.state.startDate === null && this.state.endDate === null) {
      this.setState({
        startDate: newStartDate ?? newEndDate,
        endDate: newEndDate ?? newStartDate,
      });
    } else {
      if (dateComparison(newStartDate, newEndDate) && this.state.onClickCounter > 1) {
        this.setState({
          startDate: newStartDate,
          endDate: newStartDate,
        });
      } else {
        this.setState({
          startDate: newStartDate,
          endDate: newEndDate,
        });
      }
    }
  };

  updateStartDate = (newData) => {
    if (newData !== null) {
      let startDate = moment(newData, nota.global.moment.serverDate);
      let endDate = moment(this.state.endDate, nota.global.moment.serverDate);

      if (startDate > endDate) {
        this.setState({ startDate: newData, endDate: newData, onClickCounter: 2 });
      } else {
        if (newData !== this.state.startDate) {
          this.setState({ startDate: newData, onClickCounter: 2 });
        }
      }
    } else {
      this.setState({ startDate: newData, onClickCounter: 2 });
    }
  };

  updateEndDate = (newData) => {
    if (newData !== null) {
      let startDate = moment(this.state.startDate, nota.global.moment.serverDate);
      let endDate = moment(newData, nota.global.moment.serverDate);

      if (startDate > endDate) {
        this.setState({ startDate: newData, endDate: newData, onClickCounter: 2 });
      } else {
        if (newData !== this.state.endDate) {
          this.setState({ endDate: newData, onClickCounter: 2 });
        }
      }
    } else {
      this.setState({ endDate: newData, onClickCounter: 2 });
    }
  };

  handleOutsideClick = (e) => {
    /*
      Has onClickOutsideClose Enabled
      Has isToggle Enabled
      Is Tooltip Open
      Is Click Outside Tooltip
      */
    if (this.calendarRef && this.calendarRef.current && this.state.isOpenDropdown && !this.calendarRef.current.contains(e.target)) {
      this.setState({ isOpenDropdown: false });
    }
  };

  render() {
    return (
      <StyledCalendar isOpen={this.state.isOpenDropdown}>
        <NanoFlex>
          <NanoFlex flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
            <Type.h6>{this.translation.advancedSearch.from}</Type.h6>
            <InputDate date={this.state.startDate} onDateChange={(newData) => this.updateStartDate(newData)} />
          </NanoFlex>
          <NanoFlex flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
            <Type.h6>{this.translation.advancedSearch.to}</Type.h6>
            <InputDate date={this.state.endDate} onDateChange={(newData) => this.updateEndDate(newData)} />
          </NanoFlex>
          <NanoFlex className="iconWrapper">
            <div ref={this.calendarRef}>
              <Manager>
                <Reference>
                  {(targetProps) => {
                    return (
                      <div
                        ref={targetProps.ref}
                        onClick={() => {
                          this.setState({ isOpenDropdown: !this.state.isOpenDropdown });
                        }}>
                        <NanoFlex className="icon">
                          <CalendarIcon />
                        </NanoFlex>
                      </div>
                    );
                  }}
                </Reference>
                {this.state.isOpenDropdown && (
                  <Popper placement={this._isMobile ? "top" : "bottom"}>
                    {({ ref, style, placement, arrowProps }) => (
                      <div className="popUpContainer" ref={ref} style={style} data-placement={placement}>
                        <NanoFlex className="datePickerWrapper" alignItems="flex-start">
                          <DateRangePicker
                            multipleDateRangePickers
                            mainViewMonth={this.state.startDate}
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            minDate={this.props.minDate}
                            maxDate={this.props.maxDate}
                            onClickCounter={this.state.onClickCounter}
                            onUpdateClickCounter={(newCounter) => this.setState({ onClickCounter: newCounter })}
                            onDateChange={(newStartDate, newEndDate) => this.updateMainState(newStartDate, newEndDate)}
                          />
                          {!this._isMobile && (
                            <DateRangePicker
                              multipleDateRangePickers
                              secondDefaultMonth
                              mainViewMonth={this.state.endDate}
                              startDate={this.state.startDate}
                              endDate={this.state.endDate}
                              minDate={this.props.minDate}
                              maxDate={this.props.maxDate}
                              onClickCounter={this.state.onClickCounter}
                              onUpdateClickCounter={(newCounter) => this.setState({ onClickCounter: newCounter })}
                              onDateChange={(newStartDate, newEndDate) => this.updateMainState(newStartDate, newEndDate)}
                            />
                          )}
                        </NanoFlex>
                      </div>
                    )}
                  </Popper>
                )}
              </Manager>
            </div>
          </NanoFlex>
        </NanoFlex>
      </StyledCalendar>
    );
  }
}

export default Calendar;

// Set default props
Calendar.defaultProps = {
  inputDate: mock,
};

// --- // Documentation // --- //
/*
import Calendar from './../Micro/Calendar.js';

<Calendar
    inputDate={{
        startDate: "27-02-2020",
        endDate: "27-04-2020"
    }}
    onChangeSelection={(obj) => console.log(obj)}
/>
*/
